import type { MaiConfig, CustomerData, ConsentData } from "./types";

const DEFAULT_API_ENDPOINT =
  "https://pixel.mai.co";
declare const __SDK_VERSION__: string;
const SDK_VERSION =
  typeof __SDK_VERSION__ !== "undefined" ? __SDK_VERSION__ : "headless-dev";

/** SDK 全局状态 */
class MaiConfigManager {
  private config: MaiConfig | null = null;
  private _customer: CustomerData | null = null;
  private _consent: ConsentData = {
    analytics_processing_allowed: null,
    marketing_allowed: null,
    preferences_processing_allowed: null,
    sale_of_data_allowed: null,
  };
  private _seq = 0;
  private _trackingEnabled = true;

  init(config: MaiConfig) {
    this.config = config;
    if (config.customer) this._customer = config.customer;
    if (config.consent) this._consent = { ...this._consent, ...config.consent };
  }

  get initialized() {
    return this.config !== null;
  }

  get storeDomain() {
    return this.config?.storeDomain ?? "";
  }

  get apiEndpoint() {
    return this.config?.apiEndpoint ?? DEFAULT_API_ENDPOINT;
  }

  get debug() {
    return this.config?.debug ?? false;
  }

  get version() {
    return SDK_VERSION;
  }

  get shop() {
    return {
      name: this.config?.shopName ?? "",
      myshopifyDomain: this.config?.storeDomain ?? "",
      countryCode: this.config?.shopCountryCode ?? "",
      storefrontUrl:
        this.config?.storefrontUrl ||
        (typeof window !== "undefined" ? window.location.origin : ""),
    };
  }

  get customer() {
    return this._customer;
  }

  setCustomer(data: CustomerData) {
    this._customer = { ...this._customer, ...data };
  }

  get consent(): ConsentData {
    return this._consent;
  }

  get trackingEnabled() {
    return this._trackingEnabled;
  }

  setConsent(value: boolean | ConsentData) {
    if (typeof value === "boolean") {
      this._consent = {
        analytics_processing_allowed: value,
        marketing_allowed: value,
        preferences_processing_allowed: value,
        sale_of_data_allowed: value,
      };
      this._trackingEnabled = value;
    } else {
      this._consent = { ...this._consent, ...value };
      // 如果 analytics_processing_allowed 明确为 false，停止追踪
      if (value.analytics_processing_allowed === false) {
        this._trackingEnabled = false;
      } else if (value.analytics_processing_allowed === true) {
        this._trackingEnabled = true;
      }
    }
  }

  nextSeq() {
    return ++this._seq;
  }
}

export const configManager = new MaiConfigManager();

export function log(...args: unknown[]) {
  if (configManager.debug) {
    console.log("[MAI SDK]", ...args);
  }
}
